
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

@Component
export default class TotalCost extends Vue {
  @Prop({ default: '' }) currencyCode!: string;

  get isCanadaDomesticShipment(): boolean {
    return this.$store.getters.getIsCanadaDomesticShipment;
  }
}
